export const ACTION_SEVERITY = ["1", "2", "3", "4", "5"] as const;
export type ActionSeverity = (typeof ACTION_SEVERITY)[number];
export type ActionSeverityInt = 1 | 2 | 3 | 4 | 5;

export function isActionSeverity(value: string): value is ActionSeverity {
  return (ACTION_SEVERITY as readonly string[]).includes(value);
}
